// Centralized enum for form field IDs

export enum SignUpFormField {
  Company = "company",
  Country = "country",
  YearsOpen = "yearsOpen",
  Revenue = "revenue",
  Vertical = "vertical",
  BusinessNeeds = "businessNeeds",
  CurrentSoftware = "currentSoftware",
  FirstName = "firstName",
  LastName = "lastName",
  Email = "email",
  Phone = "phone",
  Url = "url",
  Code = "code",
  Password = "password",
}
